module.exports = __webpack_public_path__ + "img/1485797142.9aedbe21.jpg";